import React, { useState } from 'react';
import { Typography, Button, Grid } from '@mui/material';
import AddTwoToneIcon from '@mui/icons-material/AddTwoTone';
import { Box } from '@mui/system';

import { Sellers } from '../../../interface/interface';

interface ISellersHeaderProps {
  sellers: Sellers[];
  setSellersData: React.Dispatch<React.SetStateAction<Sellers[]>>;
}
const SellersHeader: React.FC<ISellersHeaderProps> = ({
  sellers,
  setSellersData
}) => {
  const [open, setOpen] = useState(false);

  function onClose() {
    setOpen(false);
  }
  return (
    <Grid container justifyContent="space-between" alignItems="center">
      <Grid item>
        <Typography variant="h3" component="h3" gutterBottom>
          Sellers
        </Typography>
        <Typography variant="subtitle2">
          Welcome to the sellers section
        </Typography>
      </Grid>
      <Grid
        item
        sx={{
          display: 'flex',
          justifyContent: 'flex-end', // Align the button to the flex end
          width: { xs: '100%', sm: 'auto' }, // Full width on small screens, auto on larger
          minWidth: { sm: 400 }, // Minimum width of 400px on sm and up
          gap: 2, // Gap between child elements
          mt: { sm: 2 } // Margin top
        }}
      ></Grid>
    </Grid>
  );
};

export default SellersHeader;
